import { lazy } from '@/service/lazy'

export default [{
  name: 'Limite Usuários Loja',
  path: 'limite-usuarios',
  id: 'limite_usuarios',
  icon: 'fa fa-user-plus',
  component: lazy('app/default/gerenciador/limiteusuarios/index'),
  meta: { requireAuth: true, rules: ['gerenciar_limites_usuarios'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/limiteusuarios.js